import { IModel } from 'app/model/base/annotation';
import { } from '../base/annotation';
import { Metamodel } from 'app/model/base/model';
import { LinkedService } from '../linkedservice/linkedservice';

import { AzureKeyVault } from 'app/model/linkedservice/key-vault';
import { validateAKVLinkedserviceReference } from 'app/shared/utils/linkedservice-validation-util';
import { format } from 'app/shared/utils/string.util';
import { adfModelTypeMap } from 'app/registries/consts/adf-model-type-map-const';
import { IPrivateEndpointCompatible } from 'shell-models-lib';

@Metamodel.model({
    name: adfModelTypeMap.azureSearch.linkedServiceType,
    display: [
        format(stringResources.ModelName_LinkedServiceTemplate, stringResources.AzureSearch_DisplayText),
        format(stringResources.ModelName_LinkedServicesTemplate, stringResources.AzureSearch_DisplayText)
    ]
})
export class AzureSearchLinkedService extends LinkedService implements IPrivateEndpointCompatible {

    public static readonly MODEL: IModel;

    @Metamodel.attribute({
        display: stringResources.ModelName_ServiceName
    })
    public serviceName?: string;

    @Metamodel.attribute({
        display: stringResources.ModelName_AzureSearchAdminKey,
        constraint: {
            validator: validateAKVLinkedserviceReference
        }
    })
    public key?: string | AzureKeyVault;

    private _accountResourceID: string;

    constructor(name?: string, description?: string) {
        super(name, description);
    }

    public getPEResourceIDAndName(): { id: string, name: string } {
        const resourceName = this.serviceName;
        if (!resourceName || this._accountResourceID && !this._accountResourceID.endsWith('/' + resourceName)) {
            this._accountResourceID = undefined;
        }
        return {
            id: this._accountResourceID,
            name: resourceName
        };
    }

    public setPEResourceID(id: string): void {
        this._accountResourceID = id;
    }
}
